import { useCallback } from 'react';

import { useCurrency } from 'shared/hooks/useCurrency';
import { LOCALES } from 'shared/enums/Localization';
import {
  disambiguatedSymbols,
  formatMoneyObject,
  IFormatMoneyObjectOptions,
  suffixCurrencySymbolLocales,
} from '../utils/formatMoneyObject';
import { getLocale } from '../utils/getLocale';

export type ICurrencyLocalizerOptions = IFormatMoneyObjectOptions;

export const useCurrencyLocalizer = (locale = LOCALES.enUS) => {
  const { selectedCurrencyCode } = useCurrency(locale);

  const localize = useCallback(
    (amount: number, options?: ICurrencyLocalizerOptions) => {
      // format money object
      const moneyObject = {
        currency: selectedCurrencyCode,
        amount,
      };

      // return formatted currency
      return formatMoneyObject(moneyObject, {
        ...options,
        locale,
      });
    },
    [selectedCurrencyCode],
  );

  const getCurrencySymbol = useCallback((): {
    symbol: string;
    isSuffix: boolean;
  } => {
    const currentLocale = getLocale();

    return {
      symbol: disambiguatedSymbols.get(selectedCurrencyCode) || '$',
      isSuffix: suffixCurrencySymbolLocales.has(currentLocale),
    };
  }, [selectedCurrencyCode]);
  return { localize, getCurrencySymbol };
};
